import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import Paper from '@mui/material/Paper';
// import Draggable from 'react-draggable';
import ButtonAction from '../Button.js/SaveButton';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import Iconify from '../iconify';
// function PaperComponent({ ...props }) {
//     return (
//         <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
//             <Paper {...props} />
//         </Draggable>
//     );
// }

export default function NotificationHikvisionModal({ 
    type, 
    visibleNotification = false, 
    setVisibleNotification, 
    visibleRegister, 
    setVisibleRegister, 
    dataNotification, 
    fuctGet,
    isDelete,
    setIsDelete,
}) {
    const { t } = useTranslation();

    const tableDataHeader = [
        { id: 1, label: t('STT'), alignRight: false },
        { id: 2, label: t('ip_add_device'), alignRight: false },
        { id: 3, label: t('portno_device'), alignRight: false },
        { id: 4, label: t('status'), alignRight: false },
    ];

    const handleClose = () => {
        setVisibleNotification(!visibleNotification);
        fuctGet && fuctGet();
        isDelete && setIsDelete(false);
        setVisibleRegister(!visibleRegister);
    }

    return (
        <>
            <Dialog open={visibleNotification} onClose={handleClose} aria-labelledby="draggable-dialog-title">
                <DialogTitle id="draggable-dialog-title">
                    {t('notify_hikvision').toUpperCase() + ' '}  
                    {type === "cardNo" && (!isDelete ? t('register_card_no') : t('delete_card_no'))}
                    {type === "faceID" && (!isDelete ? t('register_face_id') : t('delete_dace_id'))}
                </DialogTitle>
                <DialogContent>
                    {dataNotification?.count_success === 0  && (
                        <Alert severity="error" style={{ marginBottom: '20px' }}>
                            {t('status_register_hikvision.error')}
                        </Alert>
                    )}
                    {(dataNotification?.count_success > 0 && dataNotification?.count_success < dataNotification?.list_device?.length) && (
                        <Alert severity="warning" style={{ marginBottom: '20px' }}>
                            {t('status_register_hikvision.warning')}
                        </Alert>
                    )}
                    {dataNotification?.count_success === dataNotification?.list_device?.length && (
                        <Alert severity="success" style={{ marginBottom: '20px' }}>
                            {t('status_register_hikvision.success')}
                        </Alert>
                    )}

                    <TableContainer sx={{ paddingTop: 0, maxHeight: 450, overflow: 'auto' }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {tableDataHeader.map((headCell, index) => (
                                        <TableCell key={index}>
                                            <TableHead>{headCell.label}</TableHead>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dataNotification?.list_device?.length > 0 && (
                                    dataNotification?.list_device?.map((item, index) => {
                                        return (
                                            <TableRow hover key={item.id} tabIndex={-1} role="checkbox">
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell align="left">
                                                    {item.ipadd_device}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item.portno_device}
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Tooltip title={item.status_reason} placement="bottom" arrow>
                                                        {item.is_success === false ? (
                                                            <Iconify icon={"mdi:error-outline"} style={{ color: 'red' }}/>
                                                        ) : (
                                                            <Iconify icon={"mdi:success-circle-outline"} style={{ color: 'green' }}/>
                                                        )}
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <ButtonAction
                        title={t('close')}
                        onClick={handleClose}
                        // variant="text"
                        type="cancel"
                    />
                </DialogActions>
            </Dialog>
        </>
    );
}
